export default __webpack_public_path__ + "3145271d5b24d156eca6aaa66221ce56.svg";